import { useTranslation } from "@sagot/i18n";
import { Kbd } from "@sagot/ui";

const SHORTCUTS = [
  { keys: ["J"], label: "next" },
  { keys: ["K"], label: "previous" },
  { keys: ["R"], label: "reply" },
  { keys: ["E"], label: "resolve" },
] as const;

/** Visible keyboard shortcut legend (desktop; the list is single-pane on mobile). */
export function ShortcutLegend() {
  const { t } = useTranslation();
  return (
    <section aria-label={t("engage.inbox.shortcuts.title")} className="hidden flex-wrap items-center gap-x-3 gap-y-1 border-r border-t border-line bg-surface px-4 py-2 text-[11px] text-fg-subtle lg:flex" data-testid="shortcut-legend">
      {SHORTCUTS.map((s) => (
        <span key={s.label} className="inline-flex items-center gap-1">
          {s.keys.map((k) => (
            <Kbd key={k}>{k}</Kbd>
          ))}
          {t(`engage.inbox.shortcuts.${s.label}`)}
        </span>
      ))}
    </section>
  );
}
